export default "__VITE_ASSET__D8QO7NkS__"